import { createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../app/api";
import { serializeError } from "../../app/shared";
import SavedSearchModel from "../../models/SavedSearchModel";

const SLICE_NAME = 'search-slice';

export const getAllSavedSearches = createAsyncThunk(
  `${SLICE_NAME}/all`,
  async (_, { rejectWithValue }) => {
    try {
      const savedSearchList: SavedSearchModel[] = await request.get("/search/save");
      return savedSearchList;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);

export const saveSearch = createAsyncThunk(
  `${SLICE_NAME}/save`,
  async (body: { name: string, savedData: string }, { rejectWithValue }) => {
    try {
      const savedSearch: SavedSearchModel = await request.post("/search/save", body);
      return savedSearch;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);

export const deleteSavedSearch = createAsyncThunk(
  `${SLICE_NAME}/delete`,
  async (id: number, { rejectWithValue }) => {
    try {
      await request.delete(`/search/save/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);

export const updateSavedSearch = createAsyncThunk(
  `${SLICE_NAME}/update`,
  async (body: { id: number, name: string, savedData: string }, { rejectWithValue }) => {
    try {
      const savedSearch: SavedSearchModel = await request.put(`/search/save`, body);
      return savedSearch;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);